import PropTypes from 'prop-types';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import ButtonText from '../button/button-text/ButtonText';
import RoundedButtonAction from '../button/rounded-button-action/RoundedButtonAction';

import style from './confirm-modal.module.less';

const ConfirmModalButton = (props) => {
    const { title, type, onClick } = props;
    if (type === 'cancel') {
        return (
            <ButtonText className={style.cancelButton} onClick={onClick}>
                {title}
            </ButtonText>
        );
    } else if (type === 'action') {
        return (
            <RoundedButtonAction className={style.confirmModalButton} onClick={onClick}>
                {title}
            </RoundedButtonAction>
        );
    } else {
        return (
            <RoundedButtonPrimary className={style.confirmModalButton} onClick={onClick}>
                {title}
            </RoundedButtonPrimary>
        );
    }
};
ConfirmModalButton.propTypes = {
    type: PropTypes.oneOf(['cancel', 'success']).isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ConfirmModalButton;
